module.exports = __webpack_public_path__ + "img/gfa.2fc340e1.jpg";